<template>
  <el-col class="esp-search-col" :span="span" :offset="offset" :pull="pull">
    <div class="esp-search-item" :style="{marginTop:gap,marginBottom:gap}">
      <div class="esp-search-label" :style="{width:labelWidth}">
        <span v-if="labelWidth!='0px'">{{ labelName }}</span>
      </div>
      <div class="esp-search-input" :style="{width:inputWidth}">
        <slot></slot>
      </div>
    </div>
  </el-col>
</template>

<script>
export default {
  name: "EspSearchItem",
  props: {
    gap: {   //边距
      type: String,
      default: "0px"
    },
    span: {   //栅格布局
      type: Number,
      default: 6
    },
    offset: {
      type: Number,
      default: 0
    },
    pull: {
      type: Number,
      default: 0
    },
    labelWidth: {  //label宽度
      type: String,
      default: "0px"
    },
    labelName: {   //label名称
      type: String,
      default: ""
    },
    inputWidth: {  //输入框宽度
      type: String,
      default: "auto"
    },
  },
}
</script>

<style scoped>
.esp-search-item {
  width: 100%;
  display: flex;
  align-items: center;
}

.esp-search-label {
  text-align: right;
  line-height: 100%;
  color: #666666;
  font-size: 14px;
  font-weight: normal;
  padding-right: 13px;
}

.esp-search-input {
  width: calc(100% - 85px);
  display: flex;
  /*justify-content: space-between;*/
  align-items: center;
}

.esp-search-col {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/EspSearchItem.vue